import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiPage } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/barvaDrobnice";

export const fetchAnimalColors = createAsyncThunk(
  "animalColor/list",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        baseUrl,
        null,
        new ApiPage().page(0).size(1000).toQueryString()
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const animalColorSlice = createSlice({
  name: "animalColors",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnimalColors.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = true;
      })
      .addCase(fetchAnimalColors.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchAnimalColors.pending, (state, _) => {
        state.isLoading = false;
        state.error = null;
      });
  },
});

export default animalColorSlice.reducer;
